/**
 * Menu chrome shared by DropdownMenu and ContextMenu, so a right-click menu
 * looks exactly like the dropdown that offers the same actions. Pair the
 * surface with MENU_MOTION_CLASSNAME (src/lib/ui/menuMotion.ts) and the
 * primitive's own transform-origin var.
 */

// The elevated floating surface: content and sub-content.
export const MENU_SURFACE_CLASSNAME =
  "min-w-[8rem] overflow-hidden rounded-xl border border-border-primary bg-bg-elevated p-1 text-text-primary shadow-large";

// Row chrome shared by every item kind: 14px text, rounded-md (nested radius:
// rounded-xl 12 − 1px border − p-1 = 7 → tie rounds down to 6), state-hover on
// keyboard focus / pointer hover.
export const MENU_ITEM_CLASSNAME =
  "relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-s-v4 text-text-primary outline-none transition-colors focus:bg-state-hover data-[disabled]:pointer-events-none data-[disabled]:opacity-50";

export const MENU_ITEM_DESTRUCTIVE_CLASSNAME =
  "text-status-error-text focus:bg-status-error-bg focus:text-status-error-text";

// Checkbox / radio rows: the indicator sits in the pl-8 gutter.
export const MENU_ITEM_INDICATOR_INSET_CLASSNAME = "pl-8";

export const MENU_ITEM_INDICATOR_CLASSNAME =
  "absolute left-2 flex h-3.5 w-3.5 items-center justify-center";

// The radio dot is drawn at 6px; the 12px dot-filled icon is a full circle.
export const MENU_RADIO_DOT_CLASSNAME = "size-1.5 fill-current";

export const MENU_SUB_TRIGGER_CLASSNAME = "data-[state=open]:bg-state-hover";

export const MENU_SUB_TRIGGER_CHEVRON_CLASSNAME = "ml-auto text-icon-secondary";

export const MENU_LABEL_CLASSNAME =
  "px-2 py-1.5 text-xs-v4 font-medium-v4 text-text-tertiary";

export const MENU_SEPARATOR_CLASSNAME = "-mx-1 my-1 h-px bg-border-primary";

export const MENU_SHORTCUT_CLASSNAME =
  "ml-auto pl-4 text-xs-v4 text-text-tertiary";
